import secureLocalStorage from "react-secure-storage";

type Headers = {
  Accept?: string;
  "Content-Type"?: string;
  Authorization?: any;
  AuthToken?: string;
  "x-api-key"?: string;
  "x-tenant-id"?: string;
  //   Access-Control-Allow-Origin": string
};

export const refreshOauthTokenIfNeeded = async () => {
  const oAuthToken: any = secureLocalStorage.getItem("OAuth") ?? null;
  const expiresAt = new Date(oAuthToken?.expires_at).getTime();
  const now = Date.now();

  let token = oAuthToken?.token;
  if (!oAuthToken || expiresAt < now) {
    token = await getOauthKey();
  }
  return token;
};

const getOauthKey = async (encryptDecrypt = true) => {
  try {
    const headers: Headers = {
      "Content-Type": "application/json",
      // "Access-Control-Allow-Origin": "*",
    };
    const url = `${process.env.REACT_APP_SERVICE_REGISTRY}oauth`;
    const dataObj = {
      client_secret: process.env.REACT_APP_SERVICE_API,
    };
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(dataObj),
      headers: headers,
    });

    // /oauth response is plaintext JSON (TO-38233; envelope removed).
    const decryptedData = await response.json();

    if (decryptedData.status === "success") {
      secureLocalStorage.setItem("OAuth", decryptedData.data);
    } else {
      throw new Error(decryptedData.message);
    }
    return decryptedData?.data?.token;
  } catch (err) {
    console.error(err);
  }
};
